export interface Product {
  id: number;
  name: string;
  supplier: string;
  supplierLocation: string;
  category: string;
  price: number;
  originalPrice: number;
  minOrder: number;
  unit: string;
  rating: number;
  reviews: number;
  sold: number;
  image: string;
  images: string[];
  badge?: string;
  inStock: boolean;
  shipping: string;
  description: string;
  specs: { label: string; value: string }[];
  warehouse: "USA" | "Canada" | "Both";
}

export const products: Product[] = [
  // ── ORIGINAL 8 PRODUCTS ──
  {
    id: 1,
    name: "Wireless Bluetooth Earbuds Pro X200",
    supplier: "ShenZhen ElectroPro Co.",
    supplierLocation: "Shenzhen, China",
    category: "Electronics",
    price: 18.99,
    originalPrice: 34.99,
    minOrder: 50,
    unit: "pairs",
    rating: 4.8,
    reviews: 2340,
    sold: 15200,
    image: "https://public.readdy.ai/ai/img_res/accd2725784d86930cfe273dab6c847f.jpg",
    images: [
      "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20white%20color%20with%20charging%20case%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20high%20quality%20consumer%20electronics&width=600&height=600&seq=prod1a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=wireless%20earbuds%20inside%20open%20charging%20case%20close%20up%20detail%20shot%2C%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting&width=600&height=600&seq=prod1b&orientation=squarish",
    ],
    badge: "Best Seller",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Premium wireless earbuds with active noise cancellation, 30-hour battery life, and IPX5 water resistance. Perfect for resellers targeting the US and Canadian markets.",
    specs: [
      { label: "Battery Life", value: "30 hours (with case)" },
      { label: "Connectivity", value: "Bluetooth 5.3" },
      { label: "Water Resistance", value: "IPX5" },
      { label: "Driver Size", value: "10mm" },
      { label: "Charging", value: "USB-C + Wireless" },
      { label: "Weight", value: "5g per earbud" },
    ],
    warehouse: "USA",
  },
  {
    id: 2,
    name: "Luxury Silk Scarf Collection",
    supplier: "FashionLink Garment Factory",
    supplierLocation: "Guangzhou, China",
    category: "Fashion",
    price: 12.50,
    originalPrice: 24.00,
    minOrder: 100,
    unit: "pieces",
    rating: 4.7,
    reviews: 876,
    sold: 8900,
    image: "https://readdy.ai/api/search-image?query=luxury%20silk%20scarf%20colorful%20floral%20pattern%20folded%20neatly%20on%20white%20background%2C%20product%20photography%2C%20fashion%20accessory%2C%20professional%20studio%20lighting%2C%20high%20quality%20textile&width=400&height=400&seq=prod2&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=luxury%20silk%20scarf%20colorful%20floral%20pattern%20folded%20neatly%20on%20white%20background%2C%20product%20photography%2C%20fashion%20accessory%2C%20professional%20studio%20lighting%2C%20high%20quality%20textile&width=600&height=600&seq=prod2a&orientation=squarish",
    ],
    badge: "Hot",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Premium 100% mulberry silk scarves with vibrant prints. Lightweight, breathable, and perfect for all seasons. High-margin product for fashion resellers.",
    specs: [
      { label: "Material", value: "100% Mulberry Silk" },
      { label: "Dimensions", value: "90cm x 90cm" },
      { label: "Weight", value: "65g" },
      { label: "Care", value: "Dry clean recommended" },
      { label: "Patterns", value: "12 designs available" },
      { label: "Packaging", value: "Gift box included" },
    ],
    warehouse: "Canada",
  },
  {
    id: 3,
    name: "Smart LED Desk Lamp with USB Charging",
    supplier: "ShenZhen ElectroPro Co.",
    supplierLocation: "Shenzhen, China",
    category: "Home Goods",
    price: 22.00,
    originalPrice: 45.00,
    minOrder: 30,
    unit: "units",
    rating: 4.9,
    reviews: 1540,
    sold: 11300,
    image: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20with%20USB%20charging%20port%20on%20white%20desk%2C%20minimalist%20design%2C%20product%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting&width=400&height=400&seq=prod3&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20with%20USB%20charging%20port%20on%20white%20desk%2C%20minimalist%20design%2C%20product%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting&width=600&height=600&seq=prod3a&orientation=squarish",
    ],
    badge: "New Arrival",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Touch-controlled smart desk lamp with 5 brightness levels, 3 color temperatures, and a built-in USB-A + USB-C charging hub. Eye-care certified.",
    specs: [
      { label: "Power", value: "12W LED" },
      { label: "Color Temp", value: "3000K / 4500K / 6500K" },
      { label: "Brightness", value: "5 levels" },
      { label: "USB Ports", value: "1x USB-A, 1x USB-C" },
      { label: "Arm Length", value: "45cm adjustable" },
      { label: "Certification", value: "Eye-care certified" },
    ],
    warehouse: "USA",
  },
  {
    id: 4,
    name: "Vitamin C Brightening Serum 30ml",
    supplier: "BeautyGlow Cosmetics Ltd.",
    supplierLocation: "Shanghai, China",
    category: "Beauty",
    price: 8.99,
    originalPrice: 19.99,
    minOrder: 200,
    unit: "bottles",
    rating: 4.8,
    reviews: 3200,
    sold: 28000,
    image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20face%20serum%20glass%20bottle%20with%20dropper%20on%20white%20background%2C%20skincare%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20orange%20and%20white%20packaging&width=400&height=400&seq=prod4&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20face%20serum%20glass%20bottle%20with%20dropper%20on%20white%20background%2C%20skincare%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20orange%20and%20white%20packaging&width=600&height=600&seq=prod4a&orientation=squarish",
    ],
    badge: "Top Seller",
    inStock: true,
    shipping: "Ships from Both Warehouses",
    description: "20% Vitamin C + Hyaluronic Acid brightening serum. Reduces dark spots, boosts collagen, and gives a radiant glow. FDA-compliant formula for US & Canada markets.",
    specs: [
      { label: "Volume", value: "30ml" },
      { label: "Key Ingredients", value: "20% Vitamin C, Hyaluronic Acid" },
      { label: "Skin Type", value: "All skin types" },
      { label: "Shelf Life", value: "24 months" },
      { label: "Compliance", value: "FDA & Health Canada" },
      { label: "Packaging", value: "Amber glass dropper bottle" },
    ],
    warehouse: "Both",
  },
  {
    id: 5,
    name: "Portable Foldable Yoga Mat",
    supplier: "HomeStyle Furniture Works",
    supplierLocation: "Foshan, China",
    category: "Sports",
    price: 15.50,
    originalPrice: 29.99,
    minOrder: 50,
    unit: "mats",
    rating: 4.6,
    reviews: 980,
    sold: 6700,
    image: "https://readdy.ai/api/search-image?query=portable%20foldable%20yoga%20mat%20rolled%20up%20with%20carrying%20strap%20on%20white%20background%2C%20fitness%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20teal%20and%20purple%20color&width=400&height=400&seq=prod5&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=portable%20foldable%20yoga%20mat%20rolled%20up%20with%20carrying%20strap%20on%20white%20background%2C%20fitness%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20teal%20and%20purple%20color&width=600&height=600&seq=prod5a&orientation=squarish",
    ],
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Eco-friendly TPE foldable yoga mat with alignment lines, non-slip surface, and carrying strap. 6mm thick for joint protection. Great for TikTok fitness influencers.",
    specs: [
      { label: "Material", value: "Eco-friendly TPE" },
      { label: "Thickness", value: "6mm" },
      { label: "Dimensions", value: "183cm x 61cm" },
      { label: "Weight", value: "1.2kg" },
      { label: "Colors", value: "8 colors available" },
      { label: "Feature", value: "Alignment lines, non-slip" },
    ],
    warehouse: "Canada",
  },
  {
    id: 6,
    name: "Stainless Steel Insulated Tumbler 40oz",
    supplier: "HomeStyle Furniture Works",
    supplierLocation: "Foshan, China",
    category: "Home Goods",
    price: 11.99,
    originalPrice: 24.99,
    minOrder: 100,
    unit: "pieces",
    rating: 4.9,
    reviews: 4100,
    sold: 32000,
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20tumbler%2040oz%20with%20handle%20and%20straw%20on%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20matte%20black%20finish&width=400&height=400&seq=prod6&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20tumbler%2040oz%20with%20handle%20and%20straw%20on%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20matte%20black%20finish&width=600&height=600&seq=prod6a&orientation=squarish",
    ],
    badge: "Trending",
    inStock: true,
    shipping: "Ships from Both Warehouses",
    description: "Double-wall vacuum insulated 40oz tumbler. Keeps drinks cold 24hrs, hot 12hrs. BPA-free, dishwasher safe. Massive seller on TikTok and Instagram.",
    specs: [
      { label: "Capacity", value: "40oz (1.18L)" },
      { label: "Material", value: "18/8 Stainless Steel" },
      { label: "Insulation", value: "Cold 24hr / Hot 12hr" },
      { label: "Lid Type", value: "Splash-proof with straw" },
      { label: "Colors", value: "15 colors available" },
      { label: "Certification", value: "BPA-free, FDA approved" },
    ],
    warehouse: "Both",
  },
  {
    id: 7,
    name: "Kids Educational Wooden Puzzle Set",
    supplier: "HomeStyle Furniture Works",
    supplierLocation: "Foshan, China",
    category: "Toys",
    price: 9.50,
    originalPrice: 18.99,
    minOrder: 100,
    unit: "sets",
    rating: 4.7,
    reviews: 1230,
    sold: 9800,
    image: "https://readdy.ai/api/search-image?query=colorful%20wooden%20educational%20puzzle%20set%20for%20kids%20on%20white%20background%2C%20toy%20product%20photography%2C%20bright%20colors%2C%20professional%20studio%20lighting%2C%20alphabet%20and%20number%20pieces&width=400&height=400&seq=prod7&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=colorful%20wooden%20educational%20puzzle%20set%20for%20kids%20on%20white%20background%2C%20toy%20product%20photography%2C%20bright%20colors%2C%20professional%20studio%20lighting%2C%20alphabet%20and%20number%20pieces&width=600&height=600&seq=prod7a&orientation=squarish",
    ],
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Non-toxic wooden puzzle set with alphabet, numbers, and shapes. ASTM & CPSC certified for US & Canada safety standards. Great for ages 2-6.",
    specs: [
      { label: "Age Range", value: "2-6 years" },
      { label: "Pieces", value: "60 pieces per set" },
      { label: "Material", value: "Non-toxic wood & paint" },
      { label: "Certification", value: "ASTM, CPSC, Health Canada" },
      { label: "Packaging", value: "Wooden storage box" },
      { label: "Themes", value: "Alphabet, Numbers, Shapes" },
    ],
    warehouse: "USA",
  },
  {
    id: 8,
    name: "Portable Mini Projector 1080P",
    supplier: "ShenZhen ElectroPro Co.",
    supplierLocation: "Shenzhen, China",
    category: "Electronics",
    price: 65.00,
    originalPrice: 129.99,
    minOrder: 20,
    unit: "units",
    rating: 4.6,
    reviews: 760,
    sold: 4200,
    image: "https://readdy.ai/api/search-image?query=portable%20mini%20projector%201080p%20on%20white%20background%2C%20compact%20home%20theater%20device%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20black%20and%20silver%20design&width=400&height=400&seq=prod8&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=portable%20mini%20projector%201080p%20on%20white%20background%2C%20compact%20home%20theater%20device%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20black%20and%20silver%20design&width=600&height=600&seq=prod8a&orientation=squarish",
    ],
    badge: "New Arrival",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Full HD 1080P native resolution mini projector with built-in Android OS, WiFi, Bluetooth, and 200-inch projection. Perfect for home theater and outdoor movie nights.",
    specs: [
      { label: "Resolution", value: "1920x1080 (Native)" },
      { label: "Brightness", value: "9500 Lumens" },
      { label: "Projection Size", value: "30-200 inches" },
      { label: "OS", value: "Android 11" },
      { label: "Connectivity", value: "WiFi 6, Bluetooth 5.0, HDMI" },
      { label: "Battery", value: "Built-in 10000mAh" },
    ],
    warehouse: "USA",
  },

  // ── 20 USA-MADE FACTORY & GARDEN PRODUCTS ──
  {
    id: 9,
    name: "Heavy-Duty Steel Garden Raised Bed Kit 4x8ft",
    supplier: "American Steel Works LLC",
    supplierLocation: "Ohio, USA",
    category: "Garden",
    price: 89.99,
    originalPrice: 139.99,
    minOrder: 5,
    unit: "kits",
    rating: 4.9,
    reviews: 1820,
    sold: 9400,
    image: "https://readdy.ai/api/search-image?query=heavy%20duty%20galvanized%20steel%20raised%20garden%20bed%20kit%204x8%20feet%20assembled%20outdoors%20with%20soil%20and%20plants%2C%20product%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20silver%20metal%20finish&width=400&height=400&seq=usa1&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=heavy%20duty%20galvanized%20steel%20raised%20garden%20bed%20kit%204x8%20feet%20assembled%20outdoors%20with%20soil%20and%20plants%2C%20product%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20silver%20metal%20finish&width=600&height=600&seq=usa1a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "American-made heavy-gauge galvanized steel raised garden bed. Rust-resistant, no-rot, lasts 20+ years. Easy bolt-together assembly. Perfect for vegetables, herbs, and flowers.",
    specs: [{ label: "Dimensions", value: "4ft x 8ft x 12in" }, { label: "Material", value: "Galvanized Steel 16-gauge" }, { label: "Assembly", value: "Tool-free bolt system" }, { label: "Warranty", value: "10 years" }, { label: "Made In", value: "Ohio, USA" }, { label: "Capacity", value: "Up to 400 lbs soil" }],
    warehouse: "USA",
  },
  {
    id: 10,
    name: "Professional Garden Hose 100ft Heavy Duty",
    supplier: "FlexPro Garden Supply Co.",
    supplierLocation: "Texas, USA",
    category: "Garden",
    price: 44.99,
    originalPrice: 69.99,
    minOrder: 10,
    unit: "units",
    rating: 4.8,
    reviews: 3100,
    sold: 18700,
    image: "https://readdy.ai/api/search-image?query=professional%20heavy%20duty%20green%20garden%20hose%20100%20feet%20coiled%20neatly%20on%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20brass%20fittings%20visible&width=400&height=400&seq=usa2&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=professional%20heavy%20duty%20green%20garden%20hose%20100%20feet%20coiled%20neatly%20on%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20brass%20fittings%20visible&width=600&height=600&seq=usa2a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "100ft commercial-grade garden hose with solid brass fittings. Kink-resistant, burst-proof up to 600 PSI. Lightweight yet ultra-durable. Made in Texas.",
    specs: [{ label: "Length", value: "100 feet" }, { label: "Diameter", value: "5/8 inch" }, { label: "Burst Pressure", value: "600 PSI" }, { label: "Fittings", value: "Solid brass" }, { label: "Made In", value: "Texas, USA" }, { label: "Warranty", value: "Lifetime" }],
    warehouse: "USA",
  },
  {
    id: 11,
    name: "Cast Iron Garden Bench with Armrests",
    supplier: "Heritage Ironworks USA",
    supplierLocation: "Pennsylvania, USA",
    category: "Garden",
    price: 219.00,
    originalPrice: 349.00,
    minOrder: 2,
    unit: "units",
    rating: 4.9,
    reviews: 640,
    sold: 2100,
    image: "https://readdy.ai/api/search-image?query=elegant%20cast%20iron%20garden%20bench%20with%20ornate%20armrests%20and%20wooden%20slats%20on%20white%20background%2C%20outdoor%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20black%20finish%2C%20classic%20design&width=400&height=400&seq=usa3&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=elegant%20cast%20iron%20garden%20bench%20with%20ornate%20armrests%20and%20wooden%20slats%20on%20white%20background%2C%20outdoor%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20black%20finish%2C%20classic%20design&width=600&height=600&seq=usa3a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Handcrafted cast iron garden bench with teak wood slats. Weather-resistant powder coat finish. Seats 2-3 adults comfortably. A timeless addition to any garden or patio.",
    specs: [{ label: "Dimensions", value: "52in W x 22in D x 36in H" }, { label: "Frame", value: "Cast iron, powder coated" }, { label: "Seat", value: "Teak hardwood slats" }, { label: "Weight Capacity", value: "500 lbs" }, { label: "Made In", value: "Pennsylvania, USA" }, { label: "Finish", value: "Matte black" }],
    warehouse: "USA",
  },
  {
    id: 12,
    name: "Organic Compost Bin 80-Gallon Tumbler",
    supplier: "GreenCycle Products USA",
    supplierLocation: "Oregon, USA",
    category: "Garden",
    price: 79.99,
    originalPrice: 119.99,
    minOrder: 5,
    unit: "units",
    rating: 4.7,
    reviews: 1450,
    sold: 7800,
    image: "https://readdy.ai/api/search-image?query=large%20black%20dual%20chamber%20compost%20tumbler%20bin%2080%20gallon%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20recycled%20plastic%20material%2C%20outdoor%20composting%20equipment&width=400&height=400&seq=usa4&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=large%20black%20dual%20chamber%20compost%20tumbler%20bin%2080%20gallon%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20recycled%20plastic%20material%2C%20outdoor%20composting%20equipment&width=600&height=600&seq=usa4a&orientation=squarish"],
    badge: "Eco-Friendly",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Dual-chamber 80-gallon compost tumbler made from 100% recycled BPA-free plastic. Produces rich compost in 2-4 weeks. Rodent-proof, UV-resistant. Made in Oregon.",
    specs: [{ label: "Capacity", value: "80 gallons (dual 40-gal)" }, { label: "Material", value: "100% recycled HDPE" }, { label: "Frame", value: "Powder-coated steel" }, { label: "Rotation", value: "360 degree tumbling" }, { label: "Made In", value: "Oregon, USA" }, { label: "Certification", value: "BPA-free, UV-resistant" }],
    warehouse: "USA",
  },
  {
    id: 13,
    name: "Stainless Steel Garden Tool Set 10-Piece",
    supplier: "ProGarden Tools Inc.",
    supplierLocation: "Michigan, USA",
    category: "Garden",
    price: 58.99,
    originalPrice: 89.99,
    minOrder: 10,
    unit: "sets",
    rating: 4.8,
    reviews: 2200,
    sold: 13500,
    image: "https://readdy.ai/api/search-image?query=professional%20stainless%20steel%20garden%20tool%20set%2010%20pieces%20including%20trowel%20rake%20pruner%20on%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20ergonomic%20handles%2C%20clean%20minimal%20style&width=400&height=400&seq=usa5&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=professional%20stainless%20steel%20garden%20tool%20set%2010%20pieces%20including%20trowel%20rake%20pruner%20on%20white%20background%2C%20product%20photography%2C%20professional%20studio%20lighting%2C%20ergonomic%20handles%2C%20clean%20minimal%20style&width=600&height=600&seq=usa5a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Complete 10-piece stainless steel garden tool set with ergonomic non-slip handles. Includes trowel, cultivator, weeder, pruner, rake, and more. Rust-proof and dishwasher safe.",
    specs: [{ label: "Pieces", value: "10 tools + carry bag" }, { label: "Material", value: "Stainless steel blades" }, { label: "Handles", value: "Ergonomic TPR grip" }, { label: "Rust Proof", value: "Yes" }, { label: "Made In", value: "Michigan, USA" }, { label: "Storage", value: "Canvas carry bag included" }],
    warehouse: "USA",
  },
  {
    id: 14,
    name: "Solar-Powered Garden Path Lights Set of 12",
    supplier: "SunBright Outdoor USA",
    supplierLocation: "Arizona, USA",
    category: "Garden",
    price: 34.99,
    originalPrice: 54.99,
    minOrder: 20,
    unit: "sets",
    rating: 4.7,
    reviews: 3800,
    sold: 22000,
    image: "https://readdy.ai/api/search-image?query=set%20of%20solar%20powered%20garden%20path%20lights%20stainless%20steel%20glowing%20warm%20white%20light%20on%20white%20background%2C%20outdoor%20lighting%20product%20photography%2C%20professional%20studio%20lighting%2C%20modern%20design%2C%20set%20of%2012&width=400&height=400&seq=usa6&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=set%20of%20solar%20powered%20garden%20path%20lights%20stainless%20steel%20glowing%20warm%20white%20light%20on%20white%20background%2C%20outdoor%20lighting%20product%20photography%2C%20professional%20studio%20lighting%2C%20modern%20design%2C%20set%20of%2012&width=600&height=600&seq=usa6a&orientation=squarish"],
    badge: "Best Seller",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Set of 12 solar-powered stainless steel path lights. Auto on/off at dusk/dawn. 8-hour runtime on full charge. Waterproof IP65. No wiring needed — just stake and go.",
    specs: [{ label: "Quantity", value: "12 lights per set" }, { label: "Solar Panel", value: "Monocrystalline" }, { label: "Runtime", value: "8 hours per charge" }, { label: "Waterproof", value: "IP65 rated" }, { label: "Made In", value: "Arizona, USA" }, { label: "Light Color", value: "Warm white 3000K" }],
    warehouse: "USA",
  },
  {
    id: 15,
    name: "Automatic Drip Irrigation System Kit",
    supplier: "AquaFlow Systems USA",
    supplierLocation: "California, USA",
    category: "Garden",
    price: 49.99,
    originalPrice: 79.99,
    minOrder: 10,
    unit: "kits",
    rating: 4.8,
    reviews: 1670,
    sold: 9200,
    image: "https://readdy.ai/api/search-image?query=automatic%20drip%20irrigation%20system%20kit%20with%20timer%20tubing%20and%20drippers%20on%20white%20background%2C%20garden%20watering%20product%20photography%2C%20professional%20studio%20lighting%2C%20clean%20minimal%20style%2C%20green%20and%20black%20components&width=400&height=400&seq=usa7&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=automatic%20drip%20irrigation%20system%20kit%20with%20timer%20tubing%20and%20drippers%20on%20white%20background%2C%20garden%20watering%20product%20photography%2C%20professional%20studio%20lighting%2C%20clean%20minimal%20style%2C%20green%20and%20black%20components&width=600&height=600&seq=usa7a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Complete drip irrigation kit with programmable digital timer, 100ft tubing, 20 adjustable drippers, and connectors. Saves up to 70% water vs. sprinklers. Covers up to 20 plants.",
    specs: [{ label: "Coverage", value: "Up to 20 plants" }, { label: "Tubing", value: "100ft included" }, { label: "Timer", value: "Digital programmable" }, { label: "Water Saving", value: "Up to 70%" }, { label: "Made In", value: "California, USA" }, { label: "Compatibility", value: "Standard hose fittings" }],
    warehouse: "USA",
  },
  {
    id: 16,
    name: "Wooden Cedar Planter Box 36-inch",
    supplier: "NatureCraft Woodworks USA",
    supplierLocation: "Vermont, USA",
    category: "Garden",
    price: 64.99,
    originalPrice: 99.99,
    minOrder: 5,
    unit: "units",
    rating: 4.9,
    reviews: 890,
    sold: 4300,
    image: "https://readdy.ai/api/search-image?query=beautiful%20natural%20cedar%20wood%20planter%20box%2036%20inch%20with%20plants%20growing%20inside%20on%20white%20background%2C%20outdoor%20garden%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%20texture&width=400&height=400&seq=usa8&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=beautiful%20natural%20cedar%20wood%20planter%20box%2036%20inch%20with%20plants%20growing%20inside%20on%20white%20background%2C%20outdoor%20garden%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%20texture&width=600&height=600&seq=usa8a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Handcrafted Western Red Cedar planter box. Naturally rot-resistant, no chemicals needed. Pre-drilled drainage holes. Perfect for herbs, vegetables, and flowers on patios and decks.",
    specs: [{ label: "Dimensions", value: "36in L x 12in W x 12in H" }, { label: "Wood", value: "Western Red Cedar" }, { label: "Drainage", value: "Pre-drilled holes" }, { label: "Finish", value: "Natural, untreated" }, { label: "Made In", value: "Vermont, USA" }, { label: "Assembly", value: "Fully assembled" }],
    warehouse: "USA",
  },
  {
    id: 17,
    name: "Electric Leaf Blower and Vacuum 3-in-1",
    supplier: "PowerGarden Tools USA",
    supplierLocation: "Georgia, USA",
    category: "Garden",
    price: 72.99,
    originalPrice: 109.99,
    minOrder: 5,
    unit: "units",
    rating: 4.7,
    reviews: 2100,
    sold: 11800,
    image: "https://readdy.ai/api/search-image?query=electric%20leaf%20blower%20vacuum%20mulcher%203%20in%201%20orange%20and%20black%20on%20white%20background%2C%20garden%20power%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20modern%20design%2C%20lightweight%20cordless&width=400&height=400&seq=usa9&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=electric%20leaf%20blower%20vacuum%20mulcher%203%20in%201%20orange%20and%20black%20on%20white%20background%2C%20garden%20power%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20modern%20design%2C%20lightweight%20cordless&width=600&height=600&seq=usa9a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "3-in-1 electric leaf blower, vacuum, and mulcher. 250 MPH airspeed, 410 CFM. Converts leaves to mulch at 16:1 ratio. Lightweight at 5.6 lbs. Corded for unlimited runtime.",
    specs: [{ label: "Airspeed", value: "250 MPH" }, { label: "Airflow", value: "410 CFM" }, { label: "Mulch Ratio", value: "16:1" }, { label: "Weight", value: "5.6 lbs" }, { label: "Made In", value: "Georgia, USA" }, { label: "Power", value: "12-amp corded" }],
    warehouse: "USA",
  },
  {
    id: 18,
    name: "Galvanized Steel Wheelbarrow 6 Cu Ft",
    supplier: "American Steel Works LLC",
    supplierLocation: "Ohio, USA",
    category: "Garden",
    price: 94.99,
    originalPrice: 149.99,
    minOrder: 3,
    unit: "units",
    rating: 4.8,
    reviews: 1340,
    sold: 6700,
    image: "https://readdy.ai/api/search-image?query=heavy%20duty%20galvanized%20steel%20wheelbarrow%206%20cubic%20feet%20with%20pneumatic%20tire%20on%20white%20background%2C%20garden%20equipment%20product%20photography%2C%20professional%20studio%20lighting%2C%20classic%20design%2C%20green%20and%20silver&width=400&height=400&seq=usa10&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=heavy%20duty%20galvanized%20steel%20wheelbarrow%206%20cubic%20feet%20with%20pneumatic%20tire%20on%20white%20background%2C%20garden%20equipment%20product%20photography%2C%20professional%20studio%20lighting%2C%20classic%20design%2C%20green%20and%20silver&width=600&height=600&seq=usa10a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Heavy-duty 6 cubic foot galvanized steel wheelbarrow with pneumatic tire. 300 lb capacity. Hardwood handles with comfort grips. Built to last a lifetime on any job site or garden.",
    specs: [{ label: "Capacity", value: "6 cubic feet" }, { label: "Load", value: "300 lbs" }, { label: "Tray", value: "Galvanized steel" }, { label: "Tire", value: "Pneumatic 16-inch" }, { label: "Made In", value: "Ohio, USA" }, { label: "Handles", value: "Hardwood with grip" }],
    warehouse: "USA",
  },
  {
    id: 19,
    name: "Outdoor Patio Umbrella 9ft UV-Resistant",
    supplier: "SunShade Outdoor USA",
    supplierLocation: "Florida, USA",
    category: "Garden",
    price: 69.99,
    originalPrice: 109.99,
    minOrder: 5,
    unit: "units",
    rating: 4.7,
    reviews: 2800,
    sold: 15600,
    image: "https://readdy.ai/api/search-image?query=large%20outdoor%20patio%20umbrella%209%20feet%20beige%20and%20tan%20color%20open%20on%20white%20background%2C%20garden%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20UV%20resistant%20fabric%2C%20aluminum%20pole&width=400&height=400&seq=usa11&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=large%20outdoor%20patio%20umbrella%209%20feet%20beige%20and%20tan%20color%20open%20on%20white%20background%2C%20garden%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20UV%20resistant%20fabric%2C%20aluminum%20pole&width=600&height=600&seq=usa11a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "9ft market patio umbrella with 50+ UPF UV protection. Fade-resistant Sunbrella fabric. Push-button tilt, crank open. Rust-proof aluminum pole. Available in 8 colors.",
    specs: [{ label: "Diameter", value: "9 feet" }, { label: "Fabric", value: "Sunbrella 50+ UPF" }, { label: "Pole", value: "Aluminum, rust-proof" }, { label: "Tilt", value: "Push-button tilt" }, { label: "Made In", value: "Florida, USA" }, { label: "Colors", value: "8 colors available" }],
    warehouse: "USA",
  },
  {
    id: 20,
    name: "Heavy-Duty Garden Kneeler and Seat Combo",
    supplier: "ProGarden Tools Inc.",
    supplierLocation: "Michigan, USA",
    category: "Garden",
    price: 38.99,
    originalPrice: 59.99,
    minOrder: 15,
    unit: "units",
    rating: 4.8,
    reviews: 1900,
    sold: 10200,
    image: "https://readdy.ai/api/search-image?query=garden%20kneeler%20and%20seat%20combo%20with%20foam%20padding%20and%20tool%20pouches%20on%20white%20background%2C%20garden%20accessory%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20black%20color%2C%20foldable%20design&width=400&height=400&seq=usa12&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=garden%20kneeler%20and%20seat%20combo%20with%20foam%20padding%20and%20tool%20pouches%20on%20white%20background%2C%20garden%20accessory%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20black%20color%2C%20foldable%20design&width=600&height=600&seq=usa12a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "2-in-1 garden kneeler and seat with thick memory foam padding. Folds flat for storage. Side tool pouches. Steel frame supports up to 330 lbs. Ideal for seniors and avid gardeners.",
    specs: [{ label: "Weight Capacity", value: "330 lbs" }, { label: "Padding", value: "2-inch memory foam" }, { label: "Frame", value: "Powder-coated steel" }, { label: "Pouches", value: "2 side tool pouches" }, { label: "Made In", value: "Michigan, USA" }, { label: "Foldable", value: "Yes, flat storage" }],
    warehouse: "USA",
  },
  {
    id: 21,
    name: "Indoor Grow Tent 4x4ft with Mylar Interior",
    supplier: "GreenCycle Products USA",
    supplierLocation: "Oregon, USA",
    category: "Garden",
    price: 54.99,
    originalPrice: 84.99,
    minOrder: 10,
    unit: "units",
    rating: 4.6,
    reviews: 1100,
    sold: 5800,
    image: "https://readdy.ai/api/search-image?query=indoor%20grow%20tent%204x4%20feet%20with%20reflective%20interior%20and%20ventilation%20ports%20on%20white%20background%2C%20hydroponic%20gardening%20product%20photography%2C%20professional%20studio%20lighting%2C%20black%20exterior%2C%20silver%20interior&width=400&height=400&seq=usa13&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=indoor%20grow%20tent%204x4%20feet%20with%20reflective%20interior%20and%20ventilation%20ports%20on%20white%20background%2C%20hydroponic%20gardening%20product%20photography%2C%20professional%20studio%20lighting%2C%20black%20exterior%2C%20silver%20interior&width=600&height=600&seq=usa13a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "4x4ft indoor grow tent with 98% reflective Mylar interior, heavy-duty 600D canvas, and multiple ventilation ports. Supports up to 110 lbs of equipment. Perfect for year-round indoor growing.",
    specs: [{ label: "Size", value: "4ft x 4ft x 6.5ft" }, { label: "Interior", value: "98% reflective Mylar" }, { label: "Canvas", value: "600D tear-proof" }, { label: "Ventilation", value: "6 ports included" }, { label: "Made In", value: "Oregon, USA" }, { label: "Load", value: "110 lbs max" }],
    warehouse: "USA",
  },
  {
    id: 22,
    name: "Terracotta Ceramic Garden Pot Set 3-Piece",
    supplier: "Heritage Ironworks USA",
    supplierLocation: "Pennsylvania, USA",
    category: "Garden",
    price: 42.99,
    originalPrice: 64.99,
    minOrder: 10,
    unit: "sets",
    rating: 4.8,
    reviews: 1560,
    sold: 8900,
    image: "https://readdy.ai/api/search-image?query=set%20of%20three%20terracotta%20ceramic%20garden%20pots%20different%20sizes%20with%20drainage%20holes%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20clay%20color%2C%20rustic%20style&width=400&height=400&seq=usa14&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=set%20of%20three%20terracotta%20ceramic%20garden%20pots%20different%20sizes%20with%20drainage%20holes%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20clay%20color%2C%20rustic%20style&width=600&height=600&seq=usa14a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Handcrafted terracotta ceramic pot set in 3 sizes (6in, 8in, 10in). Frost-resistant glaze, pre-drilled drainage holes. Ideal for succulents, herbs, and indoor plants.",
    specs: [{ label: "Sizes", value: "6in, 8in, 10in" }, { label: "Material", value: "Terracotta ceramic" }, { label: "Glaze", value: "Frost-resistant" }, { label: "Drainage", value: "Pre-drilled holes" }, { label: "Made In", value: "Pennsylvania, USA" }, { label: "Use", value: "Indoor and outdoor" }],
    warehouse: "USA",
  },
  {
    id: 23,
    name: "Oscillating Garden Sprinkler 3600 sq ft",
    supplier: "AquaFlow Systems USA",
    supplierLocation: "California, USA",
    category: "Garden",
    price: 29.99,
    originalPrice: 44.99,
    minOrder: 20,
    unit: "units",
    rating: 4.7,
    reviews: 4200,
    sold: 24000,
    image: "https://readdy.ai/api/search-image?query=oscillating%20garden%20sprinkler%20system%20with%20adjustable%20spray%20pattern%20on%20white%20background%2C%20lawn%20watering%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20black%20color%2C%20modern%20design&width=400&height=400&seq=usa15&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=oscillating%20garden%20sprinkler%20system%20with%20adjustable%20spray%20pattern%20on%20white%20background%2C%20lawn%20watering%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20black%20color%2C%20modern%20design&width=600&height=600&seq=usa15a&orientation=squarish"],
    badge: "Best Seller",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Oscillating lawn sprinkler covers up to 3,600 sq ft. 20 precision nozzles, adjustable width and range. Built-in filter prevents clogging. Connects to any standard garden hose.",
    specs: [{ label: "Coverage", value: "Up to 3,600 sq ft" }, { label: "Nozzles", value: "20 precision jets" }, { label: "Adjustment", value: "Width and range control" }, { label: "Filter", value: "Built-in clog filter" }, { label: "Made In", value: "California, USA" }, { label: "Connection", value: "Standard hose fitting" }],
    warehouse: "USA",
  },
  {
    id: 24,
    name: "Cedar Raised Planter with 5ft Trellis",
    supplier: "NatureCraft Woodworks USA",
    supplierLocation: "Vermont, USA",
    category: "Garden",
    price: 119.99,
    originalPrice: 179.99,
    minOrder: 3,
    unit: "units",
    rating: 4.9,
    reviews: 720,
    sold: 3100,
    image: "https://readdy.ai/api/search-image?query=tall%20wooden%20raised%20planter%20box%20with%20trellis%20for%20climbing%20plants%205%20feet%20tall%20on%20white%20background%2C%20garden%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20cedar%20wood%2C%20elegant%20design&width=400&height=400&seq=usa16&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=tall%20wooden%20raised%20planter%20box%20with%20trellis%20for%20climbing%20plants%205%20feet%20tall%20on%20white%20background%2C%20garden%20furniture%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20cedar%20wood%2C%20elegant%20design&width=600&height=600&seq=usa16a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Cedar raised planter with integrated 5ft trellis for climbing plants like tomatoes, cucumbers, and roses. Naturally rot-resistant. Includes liner and drainage holes. Ships flat-pack.",
    specs: [{ label: "Height", value: "5 feet with trellis" }, { label: "Planter", value: "24in L x 12in W x 12in H" }, { label: "Wood", value: "Western Red Cedar" }, { label: "Trellis", value: "Integrated lattice" }, { label: "Made In", value: "Vermont, USA" }, { label: "Liner", value: "Included" }],
    warehouse: "USA",
  },
  {
    id: 25,
    name: "Lawn Aerator Shoes with Adjustable Straps",
    supplier: "ProGarden Tools Inc.",
    supplierLocation: "Michigan, USA",
    category: "Garden",
    price: 19.99,
    originalPrice: 32.99,
    minOrder: 20,
    unit: "pairs",
    rating: 4.6,
    reviews: 3400,
    sold: 19800,
    image: "https://readdy.ai/api/search-image?query=lawn%20aerator%20shoes%20with%20metal%20spikes%20and%20adjustable%20straps%20on%20white%20background%2C%20garden%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20silver%20color%2C%20one%20size%20fits%20all&width=400&height=400&seq=usa17&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=lawn%20aerator%20shoes%20with%20metal%20spikes%20and%20adjustable%20straps%20on%20white%20background%2C%20garden%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20silver%20color%2C%20one%20size%20fits%20all&width=600&height=600&seq=usa17a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Strap-on lawn aerator shoes with 2-inch steel spikes. Aerates soil while you walk, improving water and nutrient absorption. Adjustable straps fit shoe sizes 6-13. One pair covers 5,000 sq ft.",
    specs: [{ label: "Spike Length", value: "2 inches steel" }, { label: "Spike Count", value: "13 per shoe" }, { label: "Shoe Size", value: "Fits 6-13 US" }, { label: "Coverage", value: "5,000 sq ft per use" }, { label: "Made In", value: "Michigan, USA" }, { label: "Straps", value: "3 adjustable buckles" }],
    warehouse: "USA",
  },
  {
    id: 26,
    name: "Outdoor Firewood Log Rack 4ft Steel",
    supplier: "American Steel Works LLC",
    supplierLocation: "Ohio, USA",
    category: "Garden",
    price: 54.99,
    originalPrice: 84.99,
    minOrder: 5,
    unit: "units",
    rating: 4.8,
    reviews: 1200,
    sold: 6400,
    image: "https://readdy.ai/api/search-image?query=outdoor%20firewood%20log%20rack%20storage%204%20feet%20wide%20black%20powder%20coated%20steel%20on%20white%20background%2C%20garden%20storage%20product%20photography%2C%20professional%20studio%20lighting%2C%20modern%20design%2C%20with%20cover&width=400&height=400&seq=usa18&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=outdoor%20firewood%20log%20rack%20storage%204%20feet%20wide%20black%20powder%20coated%20steel%20on%20white%20background%2C%20garden%20storage%20product%20photography%2C%20professional%20studio%20lighting%2C%20modern%20design%2C%20with%20cover&width=600&height=600&seq=usa18a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "4ft wide outdoor firewood rack with waterproof cover. Holds up to 1/4 cord of wood. Powder-coated steel resists rust and weather. Keeps wood dry and off the ground. Easy assembly.",
    specs: [{ label: "Width", value: "4 feet" }, { label: "Capacity", value: "1/4 cord of wood" }, { label: "Material", value: "Powder-coated steel" }, { label: "Cover", value: "Waterproof included" }, { label: "Made In", value: "Ohio, USA" }, { label: "Assembly", value: "30 minutes, no tools" }],
    warehouse: "USA",
  },
  {
    id: 27,
    name: "Professional Bypass Pruning Shears",
    supplier: "PowerGarden Tools USA",
    supplierLocation: "Georgia, USA",
    category: "Garden",
    price: 24.99,
    originalPrice: 39.99,
    minOrder: 20,
    unit: "units",
    rating: 4.9,
    reviews: 5600,
    sold: 31000,
    image: "https://readdy.ai/api/search-image?query=professional%20bypass%20pruning%20shears%20garden%20scissors%20with%20red%20handles%20on%20white%20background%2C%20garden%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20sharp%20stainless%20steel%20blades%2C%20ergonomic%20grip&width=400&height=400&seq=usa19&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=professional%20bypass%20pruning%20shears%20garden%20scissors%20with%20red%20handles%20on%20white%20background%2C%20garden%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20sharp%20stainless%20steel%20blades%2C%20ergonomic%20grip&width=600&height=600&seq=usa19a&orientation=squarish"],
    badge: "Best Seller",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Professional-grade bypass pruning shears with SK5 high-carbon steel blades. Cuts branches up to 3/4 inch. Ergonomic non-slip grip, safety lock. Replaceable spring and blade.",
    specs: [{ label: "Blade", value: "SK5 high-carbon steel" }, { label: "Cut Capacity", value: "3/4 inch branches" }, { label: "Handle", value: "Non-slip ergonomic" }, { label: "Safety", value: "Locking mechanism" }, { label: "Made In", value: "Georgia, USA" }, { label: "Replaceable", value: "Spring and blade" }],
    warehouse: "USA",
  },
  {
    id: 28,
    name: "Metal Garden Storage Shed 6x4ft",
    supplier: "SunShade Outdoor USA",
    supplierLocation: "Florida, USA",
    category: "Garden",
    price: 189.99,
    originalPrice: 279.99,
    minOrder: 2,
    unit: "units",
    rating: 4.7,
    reviews: 980,
    sold: 4100,
    image: "https://readdy.ai/api/search-image?query=outdoor%20metal%20garden%20storage%20shed%206x4%20feet%20with%20double%20doors%20on%20white%20background%2C%20garden%20storage%20product%20photography%2C%20professional%20studio%20lighting%2C%20gray%20and%20white%20color%2C%20modern%20design&width=400&height=400&seq=usa20&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=outdoor%20metal%20garden%20storage%20shed%206x4%20feet%20with%20double%20doors%20on%20white%20background%2C%20garden%20storage%20product%20photography%2C%20professional%20studio%20lighting%2C%20gray%20and%20white%20color%2C%20modern%20design&width=600&height=600&seq=usa20a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "6x4ft galvanized steel garden storage shed with double lockable doors. Rust-proof, weather-resistant. Stores lawn mowers, bikes, tools, and more. Ships flat-pack with all hardware.",
    specs: [{ label: "Dimensions", value: "6ft W x 4ft D x 6ft H" }, { label: "Material", value: "Galvanized steel" }, { label: "Doors", value: "Double lockable" }, { label: "Floor", value: "Included" }, { label: "Made In", value: "Florida, USA" }, { label: "Assembly", value: "2-3 hours, 2 people" }],
    warehouse: "USA",
  },

  // ── 10 CANADA-MADE PRODUCTS ──
  {
    id: 29,
    name: "Pure Maple Syrup Gift Set Grade A 3-Pack",
    supplier: "True North Maple Co.",
    supplierLocation: "Quebec, Canada",
    category: "Food",
    price: 34.99,
    originalPrice: 54.99,
    minOrder: 20,
    unit: "sets",
    rating: 4.9,
    reviews: 4800,
    sold: 28000,
    image: "https://readdy.ai/api/search-image?query=pure%20canadian%20maple%20syrup%20gift%20set%20three%20glass%20bottles%20different%20grades%20on%20white%20background%2C%20food%20product%20photography%2C%20professional%20studio%20lighting%2C%20amber%20golden%20color%2C%20maple%20leaf%20label%2C%20premium%20packaging&width=400&height=400&seq=can1&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=pure%20canadian%20maple%20syrup%20gift%20set%20three%20glass%20bottles%20different%20grades%20on%20white%20background%2C%20food%20product%20photography%2C%20professional%20studio%20lighting%2C%20amber%20golden%20color%2C%20maple%20leaf%20label%2C%20premium%20packaging&width=600&height=600&seq=can1a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Authentic Quebec Grade A pure maple syrup gift set — Golden, Amber, and Dark varieties. No additives, no preservatives. Certified organic. Perfect for gifting and gourmet cooking.",
    specs: [{ label: "Grades", value: "Golden, Amber, Dark" }, { label: "Volume", value: "250ml each (750ml total)" }, { label: "Certification", value: "Organic, non-GMO" }, { label: "Origin", value: "Quebec, Canada" }, { label: "Shelf Life", value: "4 years unopened" }, { label: "Packaging", value: "Gift box included" }],
    warehouse: "Canada",
  },
  {
    id: 30,
    name: "Canadian Spruce Raised Garden Bed 4x4ft",
    supplier: "Northern Timber Works",
    supplierLocation: "British Columbia, Canada",
    category: "Garden",
    price: 74.99,
    originalPrice: 114.99,
    minOrder: 5,
    unit: "units",
    rating: 4.8,
    reviews: 1100,
    sold: 5600,
    image: "https://readdy.ai/api/search-image?query=canadian%20spruce%20wood%20raised%20garden%20bed%204x4%20feet%20assembled%20with%20soil%20and%20vegetables%20growing%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%2C%20rustic%20style&width=400&height=400&seq=can2&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=canadian%20spruce%20wood%20raised%20garden%20bed%204x4%20feet%20assembled%20with%20soil%20and%20vegetables%20growing%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%2C%20rustic%20style&width=600&height=600&seq=can2a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Handcrafted from sustainably harvested British Columbia spruce. Naturally rot-resistant, no chemical treatment. Pre-drilled, easy assembly. Ideal for Canadian climate year-round gardening.",
    specs: [{ label: "Dimensions", value: "4ft x 4ft x 11in" }, { label: "Wood", value: "BC Spruce, sustainably sourced" }, { label: "Treatment", value: "None, naturally rot-resistant" }, { label: "Assembly", value: "Pre-drilled, 20 min" }, { label: "Made In", value: "British Columbia, Canada" }, { label: "Climate", value: "Rated for Canadian winters" }],
    warehouse: "Canada",
  },
  {
    id: 31,
    name: "Natural Beeswax Wood Polish 16oz",
    supplier: "Prairie Natural Products",
    supplierLocation: "Alberta, Canada",
    category: "Home Goods",
    price: 18.99,
    originalPrice: 28.99,
    minOrder: 30,
    unit: "jars",
    rating: 4.8,
    reviews: 2100,
    sold: 12400,
    image: "https://readdy.ai/api/search-image?query=natural%20beeswax%20wood%20polish%20conditioner%20in%20glass%20jar%2016%20oz%20on%20white%20background%2C%20natural%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20amber%20color%2C%20clean%20minimal%20label%2C%20eco%20friendly&width=400&height=400&seq=can3&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=natural%20beeswax%20wood%20polish%20conditioner%20in%20glass%20jar%2016%20oz%20on%20white%20background%2C%20natural%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20amber%20color%2C%20clean%20minimal%20label%2C%20eco%20friendly&width=600&height=600&seq=can3a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "100% natural beeswax wood polish made from Alberta beeswax and linseed oil. Conditions, protects, and restores wood furniture, cutting boards, and garden tools. Food-safe formula.",
    specs: [{ label: "Volume", value: "16oz (454g)" }, { label: "Ingredients", value: "Beeswax, linseed oil, carnauba" }, { label: "Food Safe", value: "Yes" }, { label: "Surfaces", value: "Wood, bamboo, cork" }, { label: "Made In", value: "Alberta, Canada" }, { label: "Certification", value: "All-natural, non-toxic" }],
    warehouse: "Canada",
  },
  {
    id: 32,
    name: "Organic Cold-Pressed Canola Oil 1L",
    supplier: "Prairie Natural Products",
    supplierLocation: "Alberta, Canada",
    category: "Food",
    price: 12.99,
    originalPrice: 19.99,
    minOrder: 50,
    unit: "bottles",
    rating: 4.7,
    reviews: 1800,
    sold: 9800,
    image: "https://readdy.ai/api/search-image?query=organic%20cold%20pressed%20canola%20oil%201%20liter%20glass%20bottle%20on%20white%20background%2C%20food%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20yellow%20color%2C%20clean%20minimal%20label%2C%20canadian%20organic%20certified&width=400&height=400&seq=can4&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=organic%20cold%20pressed%20canola%20oil%201%20liter%20glass%20bottle%20on%20white%20background%2C%20food%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20yellow%20color%2C%20clean%20minimal%20label%2C%20canadian%20organic%20certified&width=600&height=600&seq=can4a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Certified organic cold-pressed canola oil from Alberta prairies. High in omega-3 and omega-6. Non-GMO, no hexane extraction. Ideal for cooking, baking, and salad dressings.",
    specs: [{ label: "Volume", value: "1 Liter" }, { label: "Process", value: "Cold-pressed" }, { label: "Certification", value: "USDA Organic, non-GMO" }, { label: "Omega-3", value: "11% ALA" }, { label: "Made In", value: "Alberta, Canada" }, { label: "Smoke Point", value: "400F / 204C" }],
    warehouse: "Canada",
  },
  {
    id: 33,
    name: "Wool Blend Winter Garden Gloves",
    supplier: "Northern Timber Works",
    supplierLocation: "British Columbia, Canada",
    category: "Garden",
    price: 16.99,
    originalPrice: 26.99,
    minOrder: 30,
    unit: "pairs",
    rating: 4.8,
    reviews: 2400,
    sold: 14200,
    image: "https://readdy.ai/api/search-image?query=warm%20wool%20blend%20winter%20garden%20gloves%20with%20waterproof%20coating%20on%20white%20background%2C%20garden%20accessory%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20gray%20color%2C%20thermal%20insulated&width=400&height=400&seq=can5&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=warm%20wool%20blend%20winter%20garden%20gloves%20with%20waterproof%20coating%20on%20white%20background%2C%20garden%20accessory%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20gray%20color%2C%20thermal%20insulated&width=600&height=600&seq=can5a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Thermal wool-blend garden gloves with waterproof nitrile coating. Rated to -20C. Touchscreen-compatible fingertips. Perfect for Canadian winter gardening, snow removal, and outdoor work.",
    specs: [{ label: "Material", value: "Wool blend + nitrile coating" }, { label: "Temperature", value: "Rated to -20C / -4F" }, { label: "Touchscreen", value: "Compatible fingertips" }, { label: "Sizes", value: "S, M, L, XL" }, { label: "Made In", value: "British Columbia, Canada" }, { label: "Waterproof", value: "Yes, nitrile palm" }],
    warehouse: "Canada",
  },
  {
    id: 34,
    name: "Birch Wood End-Grain Cutting Board 18x12in",
    supplier: "True North Maple Co.",
    supplierLocation: "Quebec, Canada",
    category: "Home Goods",
    price: 44.99,
    originalPrice: 69.99,
    minOrder: 15,
    unit: "units",
    rating: 4.9,
    reviews: 3200,
    sold: 17800,
    image: "https://readdy.ai/api/search-image?query=large%20birch%20wood%20cutting%20board%2018x12%20inches%20with%20juice%20groove%20on%20white%20background%2C%20kitchen%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%2C%20end%20grain%20design%2C%20premium%20quality&width=400&height=400&seq=can6&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=large%20birch%20wood%20cutting%20board%2018x12%20inches%20with%20juice%20groove%20on%20white%20background%2C%20kitchen%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%2C%20end%20grain%20design%2C%20premium%20quality&width=600&height=600&seq=can6a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "End-grain birch cutting board handcrafted in Quebec. Self-healing surface is gentle on knife edges. Deep juice groove prevents spills. Food-safe mineral oil finish.",
    specs: [{ label: "Dimensions", value: "18in x 12in x 1.5in" }, { label: "Wood", value: "Canadian Birch end-grain" }, { label: "Finish", value: "Food-safe mineral oil" }, { label: "Juice Groove", value: "Deep perimeter groove" }, { label: "Made In", value: "Quebec, Canada" }, { label: "Care", value: "Hand wash recommended" }],
    warehouse: "Canada",
  },
  {
    id: 35,
    name: "Native Canadian Wildflower Seed Mix 1lb",
    supplier: "Prairie Natural Products",
    supplierLocation: "Alberta, Canada",
    category: "Garden",
    price: 22.99,
    originalPrice: 34.99,
    minOrder: 25,
    unit: "bags",
    rating: 4.8,
    reviews: 1600,
    sold: 8900,
    image: "https://readdy.ai/api/search-image?query=wildflower%20seed%20mix%20bag%201%20pound%20with%20colorful%20flower%20illustrations%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20paper%20packaging%2C%20canadian%20native%20species&width=400&height=400&seq=can7&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=wildflower%20seed%20mix%20bag%201%20pound%20with%20colorful%20flower%20illustrations%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20paper%20packaging%2C%20canadian%20native%20species&width=600&height=600&seq=can7a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "1lb blend of 25 native Canadian wildflower species. Attracts pollinators, butterflies, and hummingbirds. Non-GMO, pesticide-free. Covers up to 500 sq ft. Grows in all Canadian provinces.",
    specs: [{ label: "Weight", value: "1 lb (covers 500 sq ft)" }, { label: "Species", value: "25 native Canadian varieties" }, { label: "Certification", value: "Non-GMO, pesticide-free" }, { label: "Bloom Season", value: "Spring through Fall" }, { label: "Made In", value: "Alberta, Canada" }, { label: "Pollinators", value: "Attracts bees and butterflies" }],
    warehouse: "Canada",
  },
  {
    id: 36,
    name: "Winter-Proof Insulated Planter Pot 14in",
    supplier: "Northern Timber Works",
    supplierLocation: "British Columbia, Canada",
    category: "Garden",
    price: 39.99,
    originalPrice: 59.99,
    minOrder: 10,
    unit: "units",
    rating: 4.7,
    reviews: 890,
    sold: 4600,
    image: "https://readdy.ai/api/search-image?query=insulated%20outdoor%20planter%20pot%2014%20inch%20winter%20proof%20with%20double%20wall%20design%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20dark%20charcoal%20color%2C%20modern%20minimalist%20design&width=400&height=400&seq=can8&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=insulated%20outdoor%20planter%20pot%2014%20inch%20winter%20proof%20with%20double%20wall%20design%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20dark%20charcoal%20color%2C%20modern%20minimalist%20design&width=600&height=600&seq=can8a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Double-wall insulated planter pot rated to -40C. Protects plant roots from Canadian freeze-thaw cycles. Lightweight, UV-resistant recycled plastic. Drainage holes included.",
    specs: [{ label: "Diameter", value: "14 inches" }, { label: "Insulation", value: "Double-wall, rated -40C" }, { label: "Material", value: "Recycled UV-resistant plastic" }, { label: "Drainage", value: "Pre-drilled holes" }, { label: "Made In", value: "British Columbia, Canada" }, { label: "Weight", value: "2.1 lbs (lightweight)" }],
    warehouse: "Canada",
  },
  {
    id: 37,
    name: "Soy Candle Set Cedar and Pine 3-Pack",
    supplier: "True North Maple Co.",
    supplierLocation: "Quebec, Canada",
    category: "Home Goods",
    price: 28.99,
    originalPrice: 44.99,
    minOrder: 20,
    unit: "sets",
    rating: 4.9,
    reviews: 2700,
    sold: 15300,
    image: "https://readdy.ai/api/search-image?query=handcrafted%20soy%20candle%20set%20three%20pack%20cedar%20and%20pine%20scent%20in%20glass%20jars%20on%20white%20background%2C%20home%20decor%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20label%2C%20warm%20cozy%20aesthetic&width=400&height=400&seq=can9&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=handcrafted%20soy%20candle%20set%20three%20pack%20cedar%20and%20pine%20scent%20in%20glass%20jars%20on%20white%20background%2C%20home%20decor%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20label%2C%20warm%20cozy%20aesthetic&width=600&height=600&seq=can9a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Hand-poured 100% soy wax candles in Cedar, Pine, and Spruce scents. Cotton wicks, no paraffin or synthetic fragrances. 45-hour burn time each. Made in small batches in Quebec.",
    specs: [{ label: "Wax", value: "100% soy wax" }, { label: "Scents", value: "Cedar, Pine, Spruce" }, { label: "Burn Time", value: "45 hours each" }, { label: "Wick", value: "Cotton, lead-free" }, { label: "Made In", value: "Quebec, Canada" }, { label: "Volume", value: "8oz each" }],
    warehouse: "Canada",
  },
  {
    id: 38,
    name: "Organic Peat-Free Potting Mix 40L",
    supplier: "Prairie Natural Products",
    supplierLocation: "Alberta, Canada",
    category: "Garden",
    price: 19.99,
    originalPrice: 29.99,
    minOrder: 20,
    unit: "bags",
    rating: 4.8,
    reviews: 2900,
    sold: 16700,
    image: "https://readdy.ai/api/search-image?query=organic%20peat%20free%20potting%20mix%20soil%2040%20liter%20bag%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20brown%20packaging%2C%20eco%20friendly%20label%2C%20canadian%20organic%20certified&width=400&height=400&seq=can10&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=organic%20peat%20free%20potting%20mix%20soil%2040%20liter%20bag%20on%20white%20background%2C%20garden%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20brown%20packaging%2C%20eco%20friendly%20label%2C%20canadian%20organic%20certified&width=600&height=600&seq=can10a&orientation=squarish"],
    badge: "Made in Canada",
    inStock: true,
    shipping: "Ships from Canada Warehouse",
    description: "Certified organic peat-free potting mix made from composted bark, coir, and biochar. Excellent drainage and aeration. Suitable for vegetables, herbs, flowers, and containers.",
    specs: [{ label: "Volume", value: "40 liters" }, { label: "Composition", value: "Bark, coir, biochar, compost" }, { label: "Peat-Free", value: "Yes, eco-friendly" }, { label: "pH", value: "6.0 - 6.8 (ideal range)" }, { label: "Made In", value: "Alberta, Canada" }, { label: "Certification", value: "OMRI Listed Organic" }],
    warehouse: "Canada",
  },

  // ── 12 USA FARM PRODUCTS ──
  {
    id: 39,
    name: "Raw Wildflower Honey 32oz Glass Jar",
    supplier: "Golden Prairie Apiary",
    supplierLocation: "Montana, USA",
    category: "Farm Products",
    price: 18.99,
    originalPrice: 28.99,
    minOrder: 24,
    unit: "jars",
    rating: 4.9,
    reviews: 5200,
    sold: 34000,
    image: "https://readdy.ai/api/search-image?query=raw%20wildflower%20honey%20in%20large%20glass%20jar%2032oz%20with%20wooden%20honey%20dipper%20on%20clean%20white%20background%2C%20artisan%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20amber%20color%2C%20natural%20rustic%20label%2C%20american%20farm%20honey&width=400&height=400&seq=farm1&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=raw%20wildflower%20honey%20in%20large%20glass%20jar%2032oz%20with%20wooden%20honey%20dipper%20on%20clean%20white%20background%2C%20artisan%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20amber%20color%2C%20natural%20rustic%20label%2C%20american%20farm%20honey&width=600&height=600&seq=farm1a&orientation=squarish"],
    badge: "Farm Fresh",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Pure raw wildflower honey harvested from Montana meadows. Unfiltered, unpasteurized, packed with natural enzymes and antioxidants. No additives. USDA certified. Ships in glass jars.",
    specs: [{ label: "Weight", value: "32oz (2 lbs)" }, { label: "Type", value: "Raw, unfiltered wildflower" }, { label: "Certification", value: "USDA Organic" }, { label: "Origin", value: "Montana, USA" }, { label: "Shelf Life", value: "Indefinite (raw honey)" }, { label: "Packaging", value: "Glass jar with lid" }],
    warehouse: "USA",
  },
  {
    id: 40,
    name: "Organic Clover Honey Bulk 5lb Pail",
    supplier: "Golden Prairie Apiary",
    supplierLocation: "Montana, USA",
    category: "Farm Products",
    price: 42.99,
    originalPrice: 64.99,
    minOrder: 12,
    unit: "pails",
    rating: 4.8,
    reviews: 2800,
    sold: 18500,
    image: "https://readdy.ai/api/search-image?query=organic%20clover%20honey%20bulk%205%20pound%20white%20plastic%20pail%20with%20handle%20on%20white%20background%2C%20wholesale%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20light%20golden%20color%2C%20clean%20label%2C%20american%20beekeeping&width=400&height=400&seq=farm2&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=organic%20clover%20honey%20bulk%205%20pound%20white%20plastic%20pail%20with%20handle%20on%20white%20background%2C%20wholesale%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20light%20golden%20color%2C%20clean%20label%2C%20american%20beekeeping&width=600&height=600&seq=farm2a&orientation=squarish"],
    badge: "Bulk Deal",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Bulk 5lb pail of certified organic clover honey. Mild, sweet flavor perfect for baking, cooking, and food service. Sourced from Montana clover fields. Ideal for wholesale buyers and restaurants.",
    specs: [{ label: "Weight", value: "5 lbs" }, { label: "Type", value: "Clover honey, creamed" }, { label: "Certification", value: "USDA Organic, non-GMO" }, { label: "Origin", value: "Montana, USA" }, { label: "Packaging", value: "Food-grade plastic pail" }, { label: "Use", value: "Baking, cooking, food service" }],
    warehouse: "USA",
  },
  {
    id: 41,
    name: "Fresh Heirloom Tomato Seed Collection 10 Varieties",
    supplier: "Heartland Seed Farm",
    supplierLocation: "Iowa, USA",
    category: "Farm Products",
    price: 24.99,
    originalPrice: 38.99,
    minOrder: 20,
    unit: "sets",
    rating: 4.9,
    reviews: 3600,
    sold: 22000,
    image: "https://readdy.ai/api/search-image?query=heirloom%20tomato%20seed%20collection%2010%20varieties%20in%20small%20kraft%20paper%20envelopes%20arranged%20neatly%20on%20white%20background%2C%20farm%20seed%20product%20photography%2C%20professional%20studio%20lighting%2C%20colorful%20seed%20packets%2C%20organic%20gardening&width=400&height=400&seq=farm3&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=heirloom%20tomato%20seed%20collection%2010%20varieties%20in%20small%20kraft%20paper%20envelopes%20arranged%20neatly%20on%20white%20background%2C%20farm%20seed%20product%20photography%2C%20professional%20studio%20lighting%2C%20colorful%20seed%20packets%2C%20organic%20gardening&width=600&height=600&seq=farm3a&orientation=squarish"],
    badge: "Farm Fresh",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "10 rare heirloom tomato varieties including Cherokee Purple, Brandywine, Green Zebra, and more. Open-pollinated, non-GMO seeds from Iowa family farms. 90%+ germination rate guaranteed.",
    specs: [{ label: "Varieties", value: "10 heirloom types" }, { label: "Seeds per Pack", value: "25 seeds per variety" }, { label: "Germination", value: "90%+ guaranteed" }, { label: "Certification", value: "Non-GMO, open-pollinated" }, { label: "Origin", value: "Iowa, USA" }, { label: "Packaging", value: "Kraft paper envelopes" }],
    warehouse: "USA",
  },
  {
    id: 42,
    name: "Organic Whole Wheat Flour 25lb Bag",
    supplier: "Great Plains Grain Co.",
    supplierLocation: "Kansas, USA",
    category: "Farm Products",
    price: 32.99,
    originalPrice: 49.99,
    minOrder: 10,
    unit: "bags",
    rating: 4.8,
    reviews: 1900,
    sold: 11200,
    image: "https://readdy.ai/api/search-image?query=organic%20whole%20wheat%20flour%2025%20pound%20paper%20bag%20on%20white%20background%2C%20farm%20grain%20product%20photography%2C%20professional%20studio%20lighting%2C%20kraft%20paper%20packaging%2C%20wheat%20field%20illustration%2C%20american%20farm%20milled&width=400&height=400&seq=farm4&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=organic%20whole%20wheat%20flour%2025%20pound%20paper%20bag%20on%20white%20background%2C%20farm%20grain%20product%20photography%2C%20professional%20studio%20lighting%2C%20kraft%20paper%20packaging%2C%20wheat%20field%20illustration%2C%20american%20farm%20milled&width=600&height=600&seq=farm4a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Stone-ground organic whole wheat flour from Kansas hard red winter wheat. High protein content (13%), perfect for artisan bread, pasta, and baking. USDA Organic certified. Milled fresh to order.",
    specs: [{ label: "Weight", value: "25 lbs" }, { label: "Wheat Type", value: "Hard Red Winter Wheat" }, { label: "Protein", value: "13% (high protein)" }, { label: "Milling", value: "Stone-ground" }, { label: "Certification", value: "USDA Organic" }, { label: "Origin", value: "Kansas, USA" }],
    warehouse: "USA",
  },
  {
    id: 43,
    name: "Artisan Aged Cheddar Cheese 5lb Block",
    supplier: "Wisconsin Dairy Farms Co.",
    supplierLocation: "Wisconsin, USA",
    category: "Farm Products",
    price: 54.99,
    originalPrice: 79.99,
    minOrder: 6,
    unit: "blocks",
    rating: 4.9,
    reviews: 4100,
    sold: 26000,
    image: "https://readdy.ai/api/search-image?query=artisan%20aged%20cheddar%20cheese%20block%205%20pounds%20on%20white%20background%2C%20dairy%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20orange%20color%2C%20natural%20rind%2C%20premium%20wisconsin%20cheese&width=400&height=400&seq=farm5&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=artisan%20aged%20cheddar%20cheese%20block%205%20pounds%20on%20white%20background%2C%20dairy%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20orange%20color%2C%20natural%20rind%2C%20premium%20wisconsin%20cheese&width=600&height=600&seq=farm5a&orientation=squarish"],
    badge: "Farm Fresh",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Award-winning 2-year aged sharp cheddar from Wisconsin family dairy farms. Rich, complex flavor with crystalline texture. Hormone-free, rBST-free milk. Vacuum-sealed for freshness.",
    specs: [{ label: "Weight", value: "5 lbs" }, { label: "Age", value: "24 months" }, { label: "Milk", value: "Hormone-free, rBST-free" }, { label: "Flavor", value: "Sharp, crystalline" }, { label: "Origin", value: "Wisconsin, USA" }, { label: "Packaging", value: "Vacuum-sealed block" }],
    warehouse: "USA",
  },
  {
    id: 44,
    name: "Grass-Fed Butter 1lb Rolls 12-Pack",
    supplier: "Wisconsin Dairy Farms Co.",
    supplierLocation: "Wisconsin, USA",
    category: "Farm Products",
    price: 48.99,
    originalPrice: 72.99,
    minOrder: 12,
    unit: "packs",
    rating: 4.8,
    reviews: 3300,
    sold: 21000,
    image: "https://readdy.ai/api/search-image?query=grass%20fed%20butter%201%20pound%20rolls%20wrapped%20in%20parchment%20paper%20on%20white%20background%2C%20dairy%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20yellow%20color%2C%20premium%20artisan%20butter%2C%20american%20dairy%20farm&width=400&height=400&seq=farm6&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=grass%20fed%20butter%201%20pound%20rolls%20wrapped%20in%20parchment%20paper%20on%20white%20background%2C%20dairy%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20yellow%20color%2C%20premium%20artisan%20butter%2C%20american%20dairy%20farm&width=600&height=600&seq=farm6a&orientation=squarish"],
    badge: "Farm Fresh",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Creamy grass-fed butter from pasture-raised Wisconsin cows. Higher in omega-3 and CLA than conventional butter. Rich golden color, exceptional flavor. Available salted and unsalted.",
    specs: [{ label: "Weight", value: "1 lb per roll, 12-pack" }, { label: "Milk Source", value: "100% grass-fed cows" }, { label: "Fat Content", value: "84% butterfat" }, { label: "Varieties", value: "Salted and unsalted" }, { label: "Origin", value: "Wisconsin, USA" }, { label: "Packaging", value: "Parchment-wrapped rolls" }],
    warehouse: "USA",
  },
  {
    id: 45,
    name: "Organic Rolled Oats 50lb Bulk Bag",
    supplier: "Great Plains Grain Co.",
    supplierLocation: "Kansas, USA",
    category: "Farm Products",
    price: 58.99,
    originalPrice: 84.99,
    minOrder: 5,
    unit: "bags",
    rating: 4.8,
    reviews: 2200,
    sold: 13800,
    image: "https://readdy.ai/api/search-image?query=organic%20rolled%20oats%2050%20pound%20bulk%20bag%20on%20white%20background%2C%20farm%20grain%20product%20photography%2C%20professional%20studio%20lighting%2C%20kraft%20paper%20sack%2C%20oat%20grain%20texture%20visible%2C%20american%20farm%20grown&width=400&height=400&seq=farm7&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=organic%20rolled%20oats%2050%20pound%20bulk%20bag%20on%20white%20background%2C%20farm%20grain%20product%20photography%2C%20professional%20studio%20lighting%2C%20kraft%20paper%20sack%2C%20oat%20grain%20texture%20visible%2C%20american%20farm%20grown&width=600&height=600&seq=farm7a&orientation=squarish"],
    badge: "Bulk Deal",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Certified organic old-fashioned rolled oats from Kansas family farms. Gluten-free facility, non-GMO. Perfect for oatmeal, granola, baking, and food manufacturing. Bulk pricing for resellers.",
    specs: [{ label: "Weight", value: "50 lbs" }, { label: "Type", value: "Old-fashioned rolled oats" }, { label: "Certification", value: "USDA Organic, non-GMO" }, { label: "Facility", value: "Gluten-free certified" }, { label: "Origin", value: "Kansas, USA" }, { label: "Packaging", value: "Multi-wall kraft bag" }],
    warehouse: "USA",
  },
  {
    id: 46,
    name: "Fresh Dried Lavender Bundles 12-Pack",
    supplier: "Pacific Coast Lavender Farm",
    supplierLocation: "Washington, USA",
    category: "Farm Products",
    price: 29.99,
    originalPrice: 44.99,
    minOrder: 24,
    unit: "packs",
    rating: 4.9,
    reviews: 2900,
    sold: 19500,
    image: "https://readdy.ai/api/search-image?query=dried%20lavender%20bundles%20tied%20with%20twine%20on%20white%20background%2C%20farm%20botanical%20product%20photography%2C%20professional%20studio%20lighting%2C%20purple%20lavender%20flowers%2C%20aromatic%20herb%20bundle%2C%20washington%20state%20farm&width=400&height=400&seq=farm8&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=dried%20lavender%20bundles%20tied%20with%20twine%20on%20white%20background%2C%20farm%20botanical%20product%20photography%2C%20professional%20studio%20lighting%2C%20purple%20lavender%20flowers%2C%20aromatic%20herb%20bundle%2C%20washington%20state%20farm&width=600&height=600&seq=farm8a&orientation=squarish"],
    badge: "Farm Fresh",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Hand-harvested dried lavender bundles from Washington State lavender farms. Intensely fragrant Grosso variety. Perfect for home decor, sachets, culinary use, and wedding arrangements.",
    specs: [{ label: "Quantity", value: "12 bundles per pack" }, { label: "Variety", value: "Grosso lavender" }, { label: "Bundle Size", value: "10-12 inches long" }, { label: "Harvest", value: "Hand-harvested at peak bloom" }, { label: "Origin", value: "Washington, USA" }, { label: "Use", value: "Decor, culinary, sachets" }],
    warehouse: "USA",
  },
  {
    id: 47,
    name: "Organic Sunflower Seeds Roasted 10lb",
    supplier: "Heartland Seed Farm",
    supplierLocation: "Iowa, USA",
    category: "Farm Products",
    price: 26.99,
    originalPrice: 39.99,
    minOrder: 20,
    unit: "bags",
    rating: 4.7,
    reviews: 1800,
    sold: 10400,
    image: "https://readdy.ai/api/search-image?query=organic%20roasted%20sunflower%20seeds%2010%20pound%20bag%20on%20white%20background%2C%20farm%20snack%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20packaging%2C%20sunflower%20illustration%2C%20american%20farm%20grown%20seeds&width=400&height=400&seq=farm9&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=organic%20roasted%20sunflower%20seeds%2010%20pound%20bag%20on%20white%20background%2C%20farm%20snack%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20packaging%2C%20sunflower%20illustration%2C%20american%20farm%20grown%20seeds&width=600&height=600&seq=farm9a&orientation=squarish"],
    badge: "Made in USA",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Dry-roasted organic sunflower seeds from Iowa family farms. No oil, no additives. High in vitamin E, magnesium, and healthy fats. Available lightly salted or unsalted. Great for snacking and baking.",
    specs: [{ label: "Weight", value: "10 lbs" }, { label: "Roasting", value: "Dry-roasted, no oil" }, { label: "Certification", value: "USDA Organic, non-GMO" }, { label: "Varieties", value: "Salted and unsalted" }, { label: "Origin", value: "Iowa, USA" }, { label: "Packaging", value: "Resealable kraft bag" }],
    warehouse: "USA",
  },
  {
    id: 48,
    name: "Cold-Pressed Extra Virgin Olive Oil 1 Gallon",
    supplier: "California Olive Ranch",
    supplierLocation: "California, USA",
    category: "Farm Products",
    price: 44.99,
    originalPrice: 64.99,
    minOrder: 12,
    unit: "gallons",
    rating: 4.9,
    reviews: 6100,
    sold: 41000,
    image: "https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%201%20gallon%20tin%20can%20on%20white%20background%2C%20california%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20gold%20label%2C%20premium%20cold%20pressed%20olive%20oil%2C%20american%20grown&width=400&height=400&seq=farm10&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%201%20gallon%20tin%20can%20on%20white%20background%2C%20california%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20gold%20label%2C%20premium%20cold%20pressed%20olive%20oil%2C%20american%20grown&width=600&height=600&seq=farm10a&orientation=squarish"],
    badge: "Best Seller",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Award-winning California extra virgin olive oil, cold-pressed within hours of harvest. Robust, peppery flavor. USDA Organic, California Olive Oil Council certified. Ideal for restaurants and food service.",
    specs: [{ label: "Volume", value: "1 gallon (128 fl oz)" }, { label: "Acidity", value: "Less than 0.5%" }, { label: "Pressing", value: "Cold-pressed, same-day" }, { label: "Certification", value: "USDA Organic, COOC" }, { label: "Origin", value: "California, USA" }, { label: "Packaging", value: "Food-grade tin can" }],
    warehouse: "USA",
  },
  {
    id: 49,
    name: "Organic Dried Cranberries 5lb Bag",
    supplier: "Cape Cod Berry Farms",
    supplierLocation: "Massachusetts, USA",
    category: "Farm Products",
    price: 22.99,
    originalPrice: 34.99,
    minOrder: 20,
    unit: "bags",
    rating: 4.8,
    reviews: 2400,
    sold: 15600,
    image: "https://readdy.ai/api/search-image?query=organic%20dried%20cranberries%205%20pound%20bag%20on%20white%20background%2C%20farm%20berry%20product%20photography%2C%20professional%20studio%20lighting%2C%20deep%20red%20color%2C%20natural%20kraft%20packaging%2C%20massachusetts%20cranberry%20farm&width=400&height=400&seq=farm11&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=organic%20dried%20cranberries%205%20pound%20bag%20on%20white%20background%2C%20farm%20berry%20product%20photography%2C%20professional%20studio%20lighting%2C%20deep%20red%20color%2C%20natural%20kraft%20packaging%2C%20massachusetts%20cranberry%20farm&width=600&height=600&seq=farm11a&orientation=squarish"],
    badge: "Farm Fresh",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Sweetened dried cranberries from Massachusetts cranberry bogs. Lightly sweetened with organic cane sugar. Rich in antioxidants and vitamin C. Perfect for baking, trail mix, and salads.",
    specs: [{ label: "Weight", value: "5 lbs" }, { label: "Sweetener", value: "Organic cane sugar" }, { label: "Certification", value: "USDA Organic" }, { label: "Antioxidants", value: "High in proanthocyanidins" }, { label: "Origin", value: "Massachusetts, USA" }, { label: "Packaging", value: "Resealable bag" }],
    warehouse: "USA",
  },
  {
    id: 50,
    name: "Farm-Fresh Free-Range Eggs 5 Dozen",
    supplier: "Blue Ridge Poultry Farm",
    supplierLocation: "Virginia, USA",
    category: "Farm Products",
    price: 34.99,
    originalPrice: 49.99,
    minOrder: 10,
    unit: "cases",
    rating: 4.9,
    reviews: 7200,
    sold: 48000,
    image: "https://readdy.ai/api/search-image?query=farm%20fresh%20free%20range%20eggs%20in%20cardboard%20carton%20on%20white%20background%2C%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20brown%20and%20white%20eggs%2C%20natural%20rustic%20packaging%2C%20virginia%20poultry%20farm&width=400&height=400&seq=farm12&orientation=squarish",
    images: ["https://readdy.ai/api/search-image?query=farm%20fresh%20free%20range%20eggs%20in%20cardboard%20carton%20on%20white%20background%2C%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20brown%20and%20white%20eggs%2C%20natural%20rustic%20packaging%2C%20virginia%20poultry%20farm&width=600&height=600&seq=farm12a&orientation=squarish"],
    badge: "Farm Fresh",
    inStock: true,
    shipping: "Ships from USA Warehouse",
    description: "Free-range, pasture-raised eggs from Virginia family farms. Hens roam on open pastures, fed non-GMO feed. Rich orange yolks, superior flavor. Certified Humane. Ships in refrigerated packaging.",
    specs: [{ label: "Quantity", value: "5 dozen (60 eggs)" }, { label: "Raising", value: "Free-range, pasture-raised" }, { label: "Feed", value: "Non-GMO, no antibiotics" }, { label: "Certification", value: "Certified Humane, USDA" }, { label: "Origin", value: "Virginia, USA" }, { label: "Shipping", value: "Refrigerated packaging" }],
    warehouse: "USA",
  },
];

export const productCategories = ["All", "Farm Products", "Garden", "Electronics", "Fashion", "Home Goods", "Beauty", "Sports", "Toys", "Food"];
export const warehouseFilters = ["All", "USA", "Canada", "Both"];
